import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/common/ProtectedRoute';
import api from './utils/api';

// Pages publiques
import BlogHome from './pages/BlogHome';
import ArticlePage from './pages/ArticlePage';
import ContributorsPage from './pages/ContributorsPage';

// Page de connexion unifiée
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

// Pages admin
import AdminDashboard from './pages/admin/AdminDashboard';
import ArticlesList from './pages/admin/ArticlesList';
import ArticleEditor from './pages/admin/ArticleEditor';
import CategoriesManager from './pages/admin/CategoriesManager';
import UsersManager from './pages/admin/UsersManager';
import ThemeSettings from './pages/admin/ThemeSettings';
import ReviewSubmissions from './pages/admin/ReviewSubmissions';
import RewardSettings from './pages/admin/RewardSettings';
import ProfilePage from './pages/admin/ProfilePage';
import ProfileTagsSettings from './pages/admin/ProfileTagsSettings';
import UserTagsManager from './pages/admin/UserTagsManager';

function App() {
  // Charger le thème au démarrage
  useEffect(() => {
    const loadTheme = async () => {
      try {
        const response = await api.get('/settings');
        if (response.data.success) {
          const settings = response.data.settings;
          Object.entries(settings).forEach(([key, value]) => {
            if (key.startsWith('color_')) {
              const cssVar = `--${key.replace(/_/g, '-')}`;
              document.documentElement.style.setProperty(cssVar, value);
            }
          });
        }
      } catch (error) {
        console.log('Thème par défaut utilisé');
      }
    };
    
    loadTheme();
  }, []);

  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/" element={<BlogHome />} />
      <Route path="/category/:categorySlug" element={<BlogHome />} />
      <Route path="/article/:slug" element={<ArticlePage />} />
      <Route path="/contributors" element={<ContributorsPage />} />

      {/* Route login unifiée */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* Redirections anciennes routes (compatibilité) */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/contributor/login" element={<LoginPage />} />
      
      {/* Redirection contributeur vers admin unifié */}
      <Route path="/contributor/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/contributor/submit" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
      <Route path="/contributor/edit/:id" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
      
      {/* Dashboard unifié pour tous */}
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      
      {/* Gestion articles */}
      <Route path="/admin/articles" element={<ProtectedRoute><ArticlesList /></ProtectedRoute>} />
      <Route path="/admin/articles/new" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
      <Route path="/admin/articles/edit/:id" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
      
      {/* Soumissions - accessible à tous les rôles authentifiés */}
      <Route path="/admin/submissions" element={<ProtectedRoute><ReviewSubmissions /></ProtectedRoute>} />
      
      {/* Profil - accessible à tous */}
      <Route path="/admin/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      
      {/* Admin uniquement */}
      <Route path="/admin/categories" element={<ProtectedRoute adminOnly><CategoriesManager /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute adminOnly><UsersManager /></ProtectedRoute>} />
      <Route path="/admin/profile-tags" element={<ProtectedRoute adminOnly><ProfileTagsSettings /></ProtectedRoute>} />
      <Route path="/admin/user-tags" element={<ProtectedRoute adminOnly><UserTagsManager /></ProtectedRoute>} />
      <Route path="/admin/theme" element={<ProtectedRoute adminOnly><ThemeSettings /></ProtectedRoute>} />
      <Route path="/admin/rewards" element={<ProtectedRoute adminOnly><RewardSettings /></ProtectedRoute>} />
    </Routes>
  );
}

export default App;
